import { Controller } from "stimulus"

import Rails, { formDisableSelector } from "@rails/ujs";

class Item {
  constructor(name, cur_inventory, cur_price, amount, updated_price) {
    this.name = name;
    this.cur_inventory = cur_inventory;
    this.cur_price = cur_price;
    this.amount = amount;
    this.updated_price = updated_price;
  }
}

export default class extends Controller {
  static targets = ["name", "amount", "unit_price", "preview", "medicine_info", "error", "current_price_display"]

  initialize() {
    this.items = [];
  }

  connect() {
    // Store the last checked value
    this.lastMedicineName = '';
    
    // Start polling for changes every 500ms
    this.pollInterval = setInterval(() => {
      this.checkForChanges();
    }, 500);
  }
  
  disconnect() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval);
    }
  }
  
  checkForChanges() {
    const currentName = this.nameTarget.value.trim();
    if (currentName !== this.lastMedicineName) {
      this.lastMedicineName = currentName;
      this.show_medicine();
    }
  }

  show_medicine() {
    this.medicine_infoTarget.innerHTML = '';
    const medicine_name = this.nameTarget.value.trim();
    
    if (medicine_name === '') {
      // Reset price display if input is empty
      this.current_price_displayTarget.textContent = "当前单价: --";
      this.current_price_displayTarget.classList.remove('price-loaded');
      this.unit_priceTarget.placeholder = "输入新价格";
      return;
    }
    
    Rails.ajax({
      type: 'GET',
      url: "/medicines/get_by_name?medicine_name=" + encodeURIComponent(medicine_name),
      success: (result) => {
        if (result.length > 0) {
          var cur_inventory = result[0].inventory;
          var cur_price = result[0].price;
          var weekly_usage = result[0].weekly_usage;
          
          // Update the visible current price display
          this.current_price_displayTarget.textContent = `当前单价: ¥${cur_price}`;
          this.current_price_displayTarget.classList.add('price-loaded');
          
          // Also set placeholder for price input
          this.unit_priceTarget.placeholder = `输入新价格 (当前: ¥${cur_price})`;
          
          var p = document.createElement("p");
          var text = document.createTextNode(
            `当前库存：${cur_inventory}, 
                       单价：${cur_price}, 
                       每周用量： ${weekly_usage}`);
          p.appendChild(text);
          this.medicine_infoTarget.appendChild(p);
        } else {
          // Reset price display if medicine not found
          this.current_price_displayTarget.textContent = "当前单价: --";
          this.current_price_displayTarget.classList.remove('price-loaded');
          this.unit_priceTarget.placeholder = "输入新价格";
        }
      },
      error: (xhr, status, error) => {
        // Reset price display on error
        this.current_price_displayTarget.textContent = "当前单价: --";
        this.current_price_displayTarget.classList.remove('price-loaded');
        this.unit_priceTarget.placeholder = "输入新价格";
      }
    });
  }

  show_preview() {
    this.errorTarget.innerHTML = '';
    var table = this.previewTarget
    while (table.rows.length > 1) {
      table.deleteRow(1);
    }
    this.items.forEach((el, i) => {
      var row = table.insertRow(1);

      var name_cell = row.insertCell(0);
      name_cell.innerHTML = el.name;
      var cur_inventory_cell = row.insertCell(1);
      cur_inventory_cell.innerHTML = el.cur_inventory;
      var amount_cell = row.insertCell(2);
      amount_cell.innerHTML = el.amount
      var updated_inventory_cell = row.insertCell(3);
      updated_inventory_cell.innerHTML = parseInt(el.cur_inventory) + parseInt(el.amount)
      var cur_price_cell = row.insertCell(4);
      cur_price_cell.innerHTML = el.cur_price;
      var updated_price_cell = row.insertCell(5);
      if (el.updated_price) {
        updated_price_cell.innerHTML = el.updated_price
      } else {
        updated_price_cell.innerHTML = '-'
      }
      var delete_row_cell = row.insertCell(6);
      delete_row_cell.innerHTML =
        `<button data-action="click->inventory-bundle#delete" data-value=${i}>删除</button>`;
    });
    this.unit_priceTarget.style.display = "none"
  }

  add() {
    if (this.amountTarget.value == '') {
      this.errorTarget.innerHTML = `<p>进货量不能为空</p>`;
      return;
    }
    const medicine_name = this.nameTarget.value.trim();
    const amount = parseInt(this.amountTarget.value);
    var updated_price;
    if (this.unit_priceTarget.value == '') {
      updated_price = undefined
    } else {
      updated_price = parseFloat(this.unit_priceTarget.value);
    }
    var cur_inventory;
    var cur_price;
    Rails.ajax({
      type: 'GET',
      url: "/medicines/get_by_name?medicine_name=" + medicine_name,
      success: (result) => {
        if (result.length > 0) {
          cur_inventory = result[0].inventory
          cur_price = result[0].price
          const item = new Item(medicine_name, cur_inventory, cur_price, amount, updated_price)
          this.items.push(item);
          this.show_preview();
          this.nameTarget.value = '';
          this.amountTarget.value = '';
          this.unit_priceTarget.value = '';
        } else {
          this.errorTarget.innerHTML = `<p>药名 ${medicine_name} 不存在</p>`
        }
      }
    });
  }

  delete(event) {
    const index = event.target.dataset.value
    this.items.splice(index, 1);
    this.show_preview();
  }

  save() {
    var inventory_data = [];
    this.items.forEach((el) => {
      if (el.updated_price) {
        inventory_data.push({
          medicine_name: el.name,
          amount: el.amount,
          unit_price: el.updated_price,
        });
      } else {
        inventory_data.push({
          medicine_name: el.name,
          amount: el.amount,
        });
      }
    });
    var json_data = new FormData();
    json_data.append("jsondata", JSON.stringify(inventory_data));
    Rails.ajax({
      type: 'POST',
      url: "/inventory_adjustments/create_bundle",
      data: json_data,
    });
  }

  change_price() {
    if (this.unit_priceTarget.style.display == "none") {
      this.unit_priceTarget.style.display = "block";
      // Focus on the input for immediate editing
      this.unit_priceTarget.focus();
      this.unit_priceTarget.select();
    } else {
      this.unit_priceTarget.style.display = "none";
      // Clear the input when hiding
      this.unit_priceTarget.value = "";
    }
  }
}
